/* unplugin-vue-components disabled */import { render } from "./xNavItem.vue?vue&type=template&id=53f8c02b"
import script from "./xNavItem.vue?vue&type=script&lang=js"
export * from "./xNavItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__